import { render, staticRenderFns } from "./DocumentCreateEditModal.vue?vue&type=template&id=1b7685ef&scoped=true"
import script from "./DocumentCreateEditModal.vue?vue&type=script&lang=js"
export * from "./DocumentCreateEditModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentCreateEditModal.vue?vue&type=style&index=0&id=1b7685ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7685ef",
  null
  
)

export default component.exports